import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProfileManagementPage from './ProfileManagementPage.jsx';
import ProfilePermissionsPage from './ProfilePermissionsPage.jsx';

export default function ProfileManagementRoutes() {
  return (
    <Routes>
      <Route index element={<ProfileManagementPage />} />
      <Route path=":profileId/permissions" element={<ProfilePermissionsPage />} />
    </Routes>
  );
}
